export default __webpack_public_path__ + "static/media/premium-feature.615209dc.svg";